<div class="flex-grow-1 fill-parent">
  <div class="report-head" *ngIf="!isout">
    <div class="report-back">
  <button class="main-btn empty-back-btn" (click)="navigateBack()"><img src="/assets/images/back.svg" />Chart Dashboard</button></div>
    <div class="report-title detail-page-title margin-l-l">
      Total time used by day
    </div>
    <div class="report-date">
      <mat-form-field (click)="picker.open()"  class="report-picker" appearance="outline">
        <input matInput [matDatepicker]="picker" [(ngModel)]="startDate" placeholder="Start Date">
        <mat-datepicker-toggle class="picker-icon" matPrefix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker (closed)="onSelectDate()"  #picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field (click)="picker2.open()"  class="report-picker" appearance="outline">
        <input matInput [matDatepicker]="picker2" [(ngModel)]="endDate" placeholder="Start Date">
        <mat-datepicker-toggle matPrefix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker (closed)="onSelectDate()"  #picker2></mat-datepicker>
      </mat-form-field>
      <!--<mat-datepicker-toggle  matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-input  [rangePicker]="picker">
        <input matStartDate [(ngModel)]="startDate" placeholder="Start date">
        <input matEndDate [(ngModel)]="endDate" placeholder="End date">
      </mat-date-input>
      <mat-date-range-picker (closed)="onSelectDate()" #picker></mat-date-range-picker>!-->
    </div>
  </div>
  <div *ngIf="nodata">
    <label>No data in the selected period.</label>
  </div>
  <div class="report-body" [ngStyle]="!nodata ? {'visibility': 'visible'} : {'visibility': 'hidden'}">
    <ngx-charts-line-chart
        [view] = "viewsize"
        [showXAxisLabel]="showXAxisLabel"
        [showYAxisLabel]="showYAxisLabel"
        [yAxisLabel]="yAxisLabel"
        [xAxis]="xAxis"
        [yAxis]="yAxis"
        [timeline]="timeline"
        [results]="reportdata"
        [customColors]="colorScheme">
        <ng-template #tooltipTemplate let-model="model">
          <div class="tt">
            {{ model.name }}
            <br/>
            {{ model.series }}: {{ model.value }}
          </div>
      </ng-template>
      <ng-template #seriesTooltipTemplate let-model="model">
        <div class="tt">
          {{ model[0].name }}
          <br/>
          {{ model[0].series }}: {{ model[0].value }}
        </div>
      </ng-template>
    </ngx-charts-line-chart>
  </div>
  </div>
